import { useEffect, useState } from "react";
import { CalendarDays, Users, Loader2 } from "lucide-react";
import { api, apiError } from "@/lib/api";
import { MatchCard } from "@/components/MatchCard";
import { FullSpinner, Empty } from "@/components/States";
import { toast } from "sonner";

export default function Events() {
  const [events, setEvents] = useState(null);
  const [participants, setParticipants] = useState(null);
  const [busy, setBusy] = useState("");
  const load = () => api.get("/events").then(({ data }) => setEvents(data.events));
  useEffect(() => { load(); }, []);
  if (!events) return <FullSpinner />;

  const toggle = async (e) => {
    setBusy(e.id);
    try { await api.post(`/events/${e.id}/${e.registered ? "leave" : "register"}`); toast.success(e.registered ? "Left event" : "Registered"); load(); }
    catch (err) { toast.error(apiError(err)); } finally { setBusy(""); }
  };
  const viewParticipants = async (e) => {
    try { const { data } = await api.get(`/events/${e.id}/participants`); setParticipants({ event: e, list: data.results }); }
    catch (err) { toast.error(apiError(err)); }
  };

  if (participants) {
    return (
      <div className="space-y-5">
        <button onClick={() => setParticipants(null)} className="text-sm text-[#605255]">← Back to events</button>
        <h1 className="font-serif text-2xl font-bold text-[#58111A]">Suggested connections · {participants.event.name}</h1>
        {participants.list.length === 0 ? <Empty icon={Users} title="No suggestions yet" message="More participants will appear as members register." /> :
          <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">{participants.list.map((p) => <MatchCard key={p.user_id} p={p} />)}</div>}
      </div>
    );
  }

  return (
    <div className="space-y-5" data-testid="events-page">
      <h1 className="font-serif text-3xl font-bold text-[#58111A] flex items-center gap-2"><CalendarDays className="w-6 h-6 text-[#C59B27]" /> Match Events</h1>
      {events.length === 0 ? (
        <Empty icon={CalendarDays} title="No events scheduled" message="ManaJodi introduction events will appear here. Check back soon." />
      ) : events.map((e) => (
        <div key={e.id} className="mj-card p-5" data-testid={`event-${e.id}`}>
          <div className="flex items-start justify-between gap-4">
            <div>
              <h2 className="font-serif text-xl font-semibold text-[#261A1C]">{e.name}</h2>
              <p className="text-sm text-[#605255] mt-1">{e.description}</p>
              <div className="text-xs text-[#9E7B1B] mt-2 flex flex-wrap gap-x-4 gap-y-1">
                <span>📅 {e.date} {e.time}</span>{e.duration && <span>⏱ {e.duration}</span>}
                <span className="flex items-center gap-1"><Users className="w-3.5 h-3.5" /> {e.participant_count}/{e.limit}</span>
              </div>
            </div>
            <div className="flex flex-col gap-2 shrink-0">
              <button onClick={() => toggle(e)} disabled={busy === e.id} className={e.registered ? "btn-outline text-sm" : "btn-primary text-sm"} data-testid={`event-register-${e.id}`}>
                {busy === e.id ? <Loader2 className="w-4 h-4 animate-spin" /> : e.registered ? "Leave" : "Register"}
              </button>
              {e.registered && <button onClick={() => viewParticipants(e)} className="text-xs text-[#781826] font-semibold">View connections</button>}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
